import { createSelector } from 'reselect'

// PLOP_APPEND_PATTERN_ANCHOR

export const campaignGraphsSelector = createSelector(
  ({ campaignsSummary }) => campaignsSummary.campaignGraphs.data,
  data => data
)

export const campaignGraphsIsLoadingSelector = createSelector(
  ({ campaignsSummary }) => campaignsSummary.campaignGraphs.isLoading,
  isLoading => isLoading
)

export const campaignGraphsErrorSelector = createSelector(
  ({ campaignsSummary }) => campaignsSummary.campaignGraphs.error,
  error => error
)

export const campaignGraphsWasLoadedSelector = createSelector(
  ({ campaignsSummary }) => campaignsSummary.campaignGraphs.wasLoaded,
  wasLoaded => wasLoaded
)

export const campaignsSummaryFilterSelector = createSelector(
  ({ campaignsSummary }) => campaignsSummary.filter,
  filter => filter
)

export const campaignsSummaryDateRangeSelector = createSelector(
  ({ campaignsSummary }) => campaignsSummary.dateRange,
  dateRange => dateRange
)

export const campaignsSummarySortSelector = createSelector(
  ({ campaignsSummary }) => campaignsSummary.sort,
  sort => sort
)

export const selectedLineItemsSelector = createSelector(
  ({ campaignsSummary }) => campaignsSummary.selectedLineItems,
  selectedLineItems => selectedLineItems
)
